import type {
  IncidentDetailLinkedContextData,
  LinkedContextItemModel,
} from '~/app/components/incident/IncidentDetailLinkedContext/types';
import {
  buildAssetDetailPath,
  buildSiteDetailPath,
  normalizeDisplayText,
  resolveLinkedHref,
  toEmptyDisplay,
} from '~/app/components/incident/IncidentDetailLinkedContext/utils';

export function useIncidentDetailLinkedContext(
  data: IncidentDetailLinkedContextData,
): { items: LinkedContextItemModel[] } {
  const stationName = normalizeDisplayText(data.stationName);
  const location = normalizeDisplayText(data.location);
  const assetName = normalizeDisplayText(data.primaryAsset?.name);
  const serialNumber = normalizeDisplayText(data.primaryAsset?.serialNumber);

  const items: LinkedContextItemModel[] = [
    {
      kind: 'site',
      labelKey: 'detail.linkedContext.site',
      labelDefault: 'Site',
      title: toEmptyDisplay(stationName),
      secondary: location,
      href: resolveLinkedHref(data.stationId, stationName, buildSiteDetailPath),
      openLinkLabelKey: 'detail.linkedContext.openSiteInNewTab',
      openLinkLabelDefault: 'Open site details in a new tab',
    },
    {
      kind: 'asset',
      labelKey: 'detail.linkedContext.asset',
      labelDefault: 'Asset',
      title: toEmptyDisplay(assetName),
      secondary: serialNumber,
      href: resolveLinkedHref(
        data.primaryAsset?.id,
        assetName,
        buildAssetDetailPath,
      ),
      openLinkLabelKey: 'detail.linkedContext.openAssetInNewTab',
      openLinkLabelDefault: 'Open asset details in a new tab',
    },
  ];

  return { items };
}
